<template>
  <div class="gaokao-book-list">
    <div class="module-title">图书</div>
    <div class="book-list-wrap">
      <div
        class="book-list"
        v-for="(series, index) in handleBookList"
        :key="index"
      >
        <template v-for="(book, bookInd) in series">
          <div
            class="book-list-item"
            v-if="
              book.book_id != 10006 &&
              book.book_id != 10009 &&
              book.book_id != 10010 &&
              book.book_id != 10011 &&
              book.book_id != 10017 &&
              book.book_id != 10018
            "
            :key="bookInd"
          >
            <img :src="book.book_ico" alt="" class="book-cover" />
            <div class="info">
              <h4>{{ book.book_title }}</h4>
              <p v-if="book.book_isbn">ISBN：{{ book.book_isbn }}</p>
              <p>激活码：{{ book.activation_code }}</p>
              <template
                v-if="
                  (book.activation_status == 0 ||
                    book.activation_status == 2 ||
                    book.is_study_card == 1 ||
                    book.is_rx_study_card != 0) &&
                  (book.book_id == 10004 ||
                    book.book_id == 10005 ||
                    book.book_id == 10006 ||
                    book.book_id == 10007 ||
                    book.book_id == 10008 ||
                    book.book_id == 10016 ||
                    book.book_id == 10021 ||
                    book.book_id == 10022)
                "
              >
                <div class="btn btn-qxx" @click="goStudy(book)">去学习</div>
              </template>
              <template
                v-if="book.activation_status == 0 && book.series == 'brdzs'"
              >
                <div class="btn" @click="resetActivation(book, series)">
                  重新激活
                </div>
              </template>
              <template
                v-if="
                  ((book.activation_status == 2 ||
                    book.is_study_card == 1 ||
                    book.is_rx_study_card != 0) &&
                    book.series == 'brdzs') ||
                  ((book.activation_status != 1 ||
                    book.is_study_card != 0 ||
                    book.is_rx_study_card != 0) &&
                    book.book_id == 10001) ||
                  ((book.activation_status != 1 ||
                    book.is_study_card != 0 ||
                    book.is_rx_study_card != 0) &&
                    book.book_id == 10002) ||
                  ((book.activation_status != 1 ||
                    book.is_study_card != 0 ||
                    book.is_rx_study_card != 0) &&
                    book.book_id == 10003)
                "
              >
                <div class="btn btn-yjh">已激活</div>
              </template>
              <template
                v-if="
                  book.activation_status == 1 &&
                  book.is_study_card == 0 &&
                  book.is_rx_study_card == 0
                "
              >
                <div class="btn" @click="goActivation(book)">激活</div>
              </template>
            </div>
          </div>
        </template>
      </div>
    </div>

    <active-book
      ref="ActiveBook"
      @submitPopupData="submitPopupData"
    ></active-book>
    <reset-active-book
      ref="ResetActiveBook"
      @submitPopupData="submitPopupData"
    ></reset-active-book>
  </div>
</template>

<script>
import ActiveBook from "./ActiveBook.vue";
import ResetActiveBook from "./ResetActiveBook.vue";
export default {
  components: {
    ActiveBook,
    ResetActiveBook,
  },
  data() {
    return {
      handleBookList: [],
    };
  },
  computed: {
    bookList: (vm) => vm.$store.getters.bookList,
    curBook: (vm) => vm.$store.getters.curBook,
  },
  watch: {
    bookList: {
      handler(newVL) {
        this.handleBookList = [
          newVL.gaokao || [],
          newVL.brdzs || [],
          newVL.br3dzs || [],
          newVL.brdzslx || [],
        ];
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    goStudy(item) {
      this.$store.dispatch("choiceCurBook", item).then(() => {});
      sessionStorage.setItem("rypc_book", JSON.stringify(item));
      this.$router.push({
        path: "/gaokao/courseware",
      });
    },
    goActivation(item) {
      this.$refs.ActiveBook.openModal({
        book_id: item.book_id,
        book_title: item.book_title,
      });
    },
    resetActivation(item, series) {
      this.$confirm(
        "每个激活码只能激活一本书。如果激活错误，在7天内有一次重新激活的机会。一旦重新激活，原激活的图书无法继续使用。"
      ).then(() => {
        this.$refs.ResetActiveBook.openModal({
          book_id: item.book_id,
          series,
        });
      });
    },
    submitPopupData() {
      const params = {
        book_id: 0,
      };
      this.$store.dispatch("getActivateBookListAction", params).then(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.gaokao-book-list {
  border-radius: 2px;
  background: white;
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.5);
  height: 100%;
  padding: 12px 15px 36px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .book-list-wrap {
    max-height: 540px;
    margin-top: 15px;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    box-sizing: border-box;
  }
  .book-list {
    display: flex;
    flex-wrap: wrap;
    gap: 15px 10px;
    margin-bottom: 15px;

    &:last-child {
      margin-bottom: 0;
    }

    .book-list-item {
      width: calc((100% - 20px) / 3);
      min-width: 220px;
      max-width: 245px;
      height: 116px;
      display: flex;

      .book-cover {
        width: 85px;
        height: 116px;
        object-fit: cover;
        border-radius: 4px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
        flex-shrink: 0;
      }
      .info {
        flex: 1;
        overflow: hidden;
        margin-left: 5px;
        position: relative;
        h4 {
          font-size: 13px;
          font-weight: 700;
          text-overflow: ellipsis;
          overflow: hidden;
          line-height: 1.5em;
          margin-bottom: 5px;
          word-wrap: break-word;
          white-space: pre-wrap;
        }
        p {
          font-size: 10px;
          color: #3f434c;
          line-height: 1.5em;
          height: 20px;
        }
        .btn {
          position: absolute;
          bottom: 2px;
          left: 0;
          font-size: 14px;
          height: 24px;
          line-height: 24px;
          border-radius: 2px;
          color: white;
          width: 70px;
          text-align: center;
          background: #f29723;
          cursor: pointer;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          flex-shrink: 0;

          &-qxx {
            background: #32a57c;
          }
          &-yjh {
            background: #e9e9e9;
            pointer-events: none;
          }
        }
      }
    }
  }
}

// 移动端响应式样式
@media (max-width: 1024px) {
  .gaokao-book-list {
    height: auto !important;
    min-height: calc(100vh - 300px) !important;
    padding: 15px !important;

    .module-title {
      padding-left: 14px;
      font-size: 14px;
      color: #000;
      font-weight: 700;
      position: relative;
      line-height: 18px;

      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 1px;
        width: 4px;
        height: 16px;
        background: #d8474c;
      }
    }

    .book-list-wrap {
      max-height: none !important;
      margin-top: 20px !important;
    }

    .book-list {
      justify-content: center !important;

      .book-list-item {
        width: 100% !important;
        max-width: 400px !important;
        height: auto !important;
        min-height: 120px !important;
        margin: 0 0 20px 0 !important;
        padding: 15px !important;
        border: 1px solid #eee !important;
        border-radius: 8px !important;

        .book-cover {
          width: 80px !important;
          height: 110px !important;
          object-fit: cover !important;
          border-radius: 6px !important;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
          flex-shrink: 0 !important;
        }

        .info {
          margin-left: 15px !important;

          h4 {
            font-size: 16px !important;
            margin-bottom: 8px !important;
            line-height: 1.4 !important;
            white-space: nowrap !important;
            overflow: hidden !important;
            text-overflow: ellipsis !important;
          }

          p {
            font-size: 12px !important;
            height: auto !important;
            margin-bottom: 5px !important;
            line-height: 1.6 !important;
            white-space: nowrap !important;
            overflow: hidden !important;
            text-overflow: ellipsis !important;
          }

          .btn {
            position: static !important;
            margin-top: 10px !important;
            width: 80px !important;
            height: 24px !important;
            line-height: 24px !important;
            font-size: 14px !important;
            border-radius: 4px !important;
            white-space: nowrap !important;
            overflow: hidden !important;
            text-overflow: ellipsis !important;
            flex-shrink: 0 !important;
          }
        }
      }
    }
  }
}

// 平板端响应式样式
@media (max-width: 1042px) and (min-width: 1025px) {
  .gaokao-book-list {
    padding: 15px !important;

    .book-list {
      margin-bottom: 20px !important;

      &:last-child {
        margin-bottom: 0 !important;
      }

      .book-list-item {
        width: 220px !important;
        margin-right: 10px !important;
        margin-bottom: 20px !important;
      }
    }
  }
}

// 小屏幕设备优化
@media (max-width: 768px) {
  .gaokao-book-list {
    padding: 12px !important;

    .book-list {
      .book-list-item {
        max-width: 100% !important;
        padding: 12px !important;
        margin-bottom: 15px !important;

        .book-cover {
          width: 75px !important;
          height: 105px !important;
          object-fit: cover !important;
          border-radius: 5px !important;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1) !important;
          flex-shrink: 0 !important;
        }

        .info {
          margin-left: 12px !important;

          h4 {
            font-size: 15px !important;
            white-space: nowrap !important;
            overflow: hidden !important;
            text-overflow: ellipsis !important;
          }

          p {
            font-size: 11px !important;
            white-space: nowrap !important;
            overflow: hidden !important;
            text-overflow: ellipsis !important;
          }

          .btn {
            width: 80px !important;
            height: 24px !important;
            line-height: 24px !important;
            font-size: 13px !important;
            white-space: nowrap !important;
            overflow: hidden !important;
            text-overflow: ellipsis !important;
            flex-shrink: 0 !important;
          }
        }
      }
    }
  }
}

// 超小屏幕设备优化
@media (max-width: 480px) {
  .gaokao-book-list {
    padding: 10px !important;

    .book-list {
      .book-list-item {
        padding: 10px !important;
        margin-bottom: 12px !important;

        .book-cover {
          width: 70px !important;
          height: 100px !important;
          object-fit: cover !important;
          border-radius: 4px !important;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
          flex-shrink: 0 !important;
        }

        .info {
          margin-left: 10px !important;

          h4 {
            font-size: 14px !important;
            white-space: nowrap !important;
            overflow: hidden !important;
            text-overflow: ellipsis !important;
          }

          p {
            font-size: 10px !important;
            white-space: nowrap !important;
            overflow: hidden !important;
            text-overflow: ellipsis !important;
          }

          .btn {
            width: 80px !important;
            height: 24px !important;
            line-height: 24px !important;
            font-size: 12px !important;
            white-space: nowrap !important;
            overflow: hidden !important;
            text-overflow: ellipsis !important;
            flex-shrink: 0 !important;
          }
        }
      }
    }
  }
}

// 确保在所有设备上都没有水平滚动
@media (max-width: 1200px) {
  .gaokao-book-list {
    overflow-x: hidden !important;

    .book-list-wrap,
    .book-list {
      overflow-x: hidden !important;
    }
  }
}
</style>
